import 'keen-slider/keen-slider.min.css';
import React, { useState, useEffect, useRef } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useOrders } from '../../pages/DefaultPage/connect/Orders';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { DateObject } from 'react-multi-date-picker';
import moment from 'jalali-moment';
import Slider from "react-slick";
import { baseUrl, baseUrlWithoutApi } from '../../baseurl';
import { useUserInfo } from '../../pages/Profile/connect/User';
import "./ADstyles.css"
import CheckImg from '../CheckImg/CheckImg';
import { useViewedAdsStore } from '../../pages/AdvertiseDetail/useViewedAdsStore';

function TwoCard({ key, item, onClick, isSearch, isInAllAds }) {
    const { viewedAdIds } = useViewedAdsStore();


    const defultImgs = { 1: "/imgs/pelake-man-noUserImageFoundforAd.svg", 2: "/imgs/pelake-man-noUserImageFoundforAd.svg", 3: "/imgs/pelake-man-noUserImageFoundforAd.svg", 4: "/imgs/pelake-man-noUserImageFoundforAd.svg" }
    const rndInt = Math.floor(Math.random() * 4) + 1
    // console.log("rndInt", rndInt)
    // slider
    const orderImg = useOrders((state) => state.orderImg);
    const loader = useOrders((state) => state.loader);
    const { getDetailsOrders } = useOrders((state) => state.actions);
    const isUserBlocked = useUserInfo((state) => state.isUserBlocked)
    const { getIsUserBlocked } = useUserInfo((state) => state.actions);

    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 1,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel)
        },
        created() {
            setLoaded(true)
        },
    })


    const getIsUserBlockedHandler = async () => {
        await getIsUserBlocked(localStorage.getItem("usruserCode"), localStorage.getItem("pelakToken"))
    }

    // const moveDetailPageHandler = async () => {
    //     if (onClick) {
    //         onClick()
    //         return;
    //     }
    //     localStorage.setItem("usruserCode", item.usruserCode)
    //     await getIsUserBlockedHandler()
    //     if (isUserBlocked) {
    //         navigate(`/AdvertiseDetail/${item.id}`)

    //     } else {
    //         navigate(`/AdvertiseDetail/${item.id}`)
    //     }


    // }
    const moveDetailPageHandler = async () => {
        if (onClick) {
            onClick();
            return;
        }
        localStorage.setItem("usruserCode", item.usruserCode);
        await getIsUserBlockedHandler();
        // No need to navigate programmatically, as the Link will handle navigation
    };
    const dateNew = moment.utc(new Date(), "UTC/GMT").local().format().slice(0, 16);
    const [dateStatus, setDateStatus] = useState("no date")
    const dateStatusHandler = async () => {
        if (item) {
            // if (item.adsDateTime.slice(0, 13) == dateNew.slice(0, 13)) {
            //     setDateStatus("دقایقی پیش")
            // }
            // else if (item.adsDateTime.slice(0, 11) == dateNew.slice(0, 11)) {
            //     setDateStatus("ساعاتی پیش")
            // }
            // else if (item.adsDateTime.slice(8, 10) == dateNew.slice(8, 10) - 1) {
            //     setDateStatus("روز پیش")
            // }

            // else {
            setDateStatus(new DateObject(item.updatedAt?.slice(0, 10))?.convert(persian, persian_fa)?.format())
            // }
        }
    }
    useEffect(() => {
        dateStatusHandler()
    }, [])




    function CheckImage(imageUrlToCheck, adsMainCategoryCode) {

        const imageUrl = `${baseUrlWithoutApi}${imageUrlToCheck}`;
        // console.log("imageUrlToCheck", imageUrl);

        const [imageExists, setImageExists] = useState(false);

        useEffect(() => {
            const img = new Image();
            img.src = imageUrl;

            img.onload = () => setImageExists(true);
            img.onerror = () => setImageExists(false);
        }, [imageUrl]);

        return (
            // <div className={`flex rounded w-full h-full border border-b border-b-2 bg-gray-200
            //   bg-no-repeat TwoCard  bg-center bg-cover ${(isSearch || isInAllAds ) && "style-for-fixed-w-h-2"}`}
            //     style={{ backgroundImage: `url(${imageExists ? imageUrl : defultImgs[rndInt]})` }}></div>
            <div
                className={`bg-center bg-cover bg-gray-200 flex h-full items-center justify-center rounded-md w-full relative`}
                style={{
                    backgroundImage: `url(${setImageExists ? imageUrl : defultImgs[rndInt]})`,
                }}
            >
                {adsMainCategoryCode === 8 ?
                    <img src='/icons/taavon-two-card.svg' alt='' className='absolute left-0 bottom-2' /> :
                    <img src='/icons/pelak-two-card.svg' alt='' className='absolute left-0 bottom-2' />}
            </div>
        );
    }
    // console.log("rndInt", defultImgs[rndInt]);
    const isViewed = viewedAdIds.includes(String(item.id))
    console.log(item, "item in 2 cards");


    return (
        <>

            <Link to={`/AdvertiseDetail/${item.id}`} onClick={moveDetailPageHandler} className={`single_frame  ${isViewed ? `border-orange-500` : `border-neutral-500`}`}>
                {item && (
                    <>
                        <div className={`p-1 w-full`}>
                            <p className={`my-2 text-start font-bold text-[16px]`}>
                                {item.adsTitle}
                            </p>
                            {item.detailInMasterCode == 9 ? (
                                <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                                    <div className='flex w-full justify-between'>
                                        <p>کمترین اجاره:</p>
                                        {item.minShortTermRentPrice ? (
                                            <p>{item.minShortTermRentPrice.toLocaleString("fa")} تومان</p>
                                        ) : (
                                            <p>توافقی</p>
                                        )}
                                    </div>
                                </div>
                            ) : item.adsMainCategoryCode == 1 ? (
                                <div className={`grid grid-cols-1 gap-2`}>
                                    {item.br_AdsPrptyTradeTypeCode == 7 && (
                                        <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500 '>
                                            <div className='flex w-full justify-between'>
                                                <p>قیمت تا:</p>
                                                {item.br_BuyPriceTo ? (
                                                    <p>{item.br_BuyPriceTo.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                ) : (
                                                    <p>توافقی</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {item.br_AdsPrptyTradeTypeCode == 8 && (
                                        <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                                            <div className='flex w-full justify-between'>
                                                <p>ودیعه تا:</p>
                                                {item.br_RentDeposintTo ? (
                                                    <p>{item.br_RentDeposintTo.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                ) : (
                                                    <p>توافقی</p>
                                                )}
                                            </div>
                                            <div className='flex w-full justify-between'>
                                                <p>اجاره تا:</p>
                                                {item.br_RentPriceTo ? (
                                                    <p>{item.br_RentPriceTo.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                ) : (
                                                    <p>توافقی</p>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {!item.br_IsApplicantRentBuyProperty && (
                                        <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                                            {item.isForRent ? (
                                                <div className='flex w-full'>
                                                    <p className='ml-2 !text-gray-500'>ودیعه:</p>
                                                    {item.deposit ? (
                                                        <p>{item.deposit.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                    ) : (
                                                        <p>رایگان</p>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className='flex w-full'>
                                                    <p className='ml-2 !text-gray-500'>متری:</p>
                                                    {item.pricePerMeter ? (
                                                        <p>{item.pricePerMeter.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                    ) : (
                                                        <p>توافقی</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {!item.br_IsApplicantRentBuyProperty && (
                                        <div className='flex justify-between gap-2 items-center flex-col text-[14px] font-bold text-gray-500'>
                                            {item.isForRent ? (
                                                <div className='flex w-full'>
                                                    <p className='ml-2 !text-gray-500'>اجــاره:</p>
                                                    {item.rentPerMonth ? (
                                                        <p>{item.rentPerMonth.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                    ) : (
                                                        <p>رایگان</p>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className='flex w-full'>
                                                    <p className='ml-2 !text-gray-500'>کـــــل:</p>
                                                    {item.totalPrice ? (
                                                        <p>{item.totalPrice.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                                    ) : (
                                                        <p> توافقی </p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='flex w-full items-center justify-between font-bold text-gray-500'>
                                    <p>قیمت:</p>
                                    {item.price ? (
                                        <p>{item.price.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                    ) : (
                                        <p>توافقی</p>
                                    )}
                                </div>
                            )}
                            <div className={`flex w-full justify-between items-center text-gray-500 text-sm hidden`}>
                                <p>قیمت:</p>
                                {item.price ? (
                                    <p>{item.price.toLocaleString("fa").replace(/٬/g, ",")} تومان</p>
                                ) : (
                                    <p>توافقی</p>
                                )}
                            </div>
                            {console.log(item.area, "item.area ")
                            }
                            <p className='w-full text-[12px] font-bold !text-gray-500 mt-1 flex  gap-1 '>
                                {(item.area && item.area !== "-") ? (
                                    <> <span>در </span>
                                        {item.area}
                                    </>
                                ) : (<>{item.city}</>)}

                            </p>
                            <div className='flex items-center justify-between'>
                                <p className='!text-gray-500 text-[14px]'>
                                    {dateStatus}
                                </p>
                                <div className='text-gray-500 text-[12px] hidden items-center justify-between'>
                                    <div className='flex flex-col justify-center items-center p-1 rounded'>
                                        <img src={localStorage.getItem("veeu-dark-mode") ? "/icons/dark-heart-like.svg" : "/icons/heart.svg"} className='w-3.5 h-3.5' alt="" />
                                        <p>{item.likesCount == 0 ? "--" : item.likesCount.toLocaleString("fa")}</p>
                                    </div>
                                    <div className='flex flex-col justify-center items-center  p-1 rounded'>
                                        <img src={localStorage.getItem("veeu-dark-mode") ? "/icons/dark-view-eye.svg" : "/icons/eye-icon.svg"} className='w-3.5 h-3.5' alt="" />
                                        <p>{item.viewsCount == 0 ? "--" : item.viewsCount.toLocaleString("fa")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='overflow-hidden rounded h-full style-for-fixed-w-h'>
                            {item.firstMasterImage !== "" ? (
                                CheckImage(item.firstMasterImage, item.adsMainCategoryCode)
                            ) : (
                                <div className='w-full h-full flex items-center justify-center bg-gray-200 rounded'>
                                    <div className='relative'>   <img className="flex border border-b border-b-2 p-[15px] bg-no-repeat TwoCard rounded"
                                        src={defultImgs[rndInt]} alt="img1" />
                                        {item.adsMainCategoryCode === 8 ?
                                            <img src='/icons/taavon-two-card.svg' alt='' className='absolute left-0 bottom-2' /> :
                                            <img src='/icons/pelak-two-card.svg' alt='' className='absolute left-0 bottom-2' />}

                                    </div >

                                    {/* <img src='/icons/pelak-two-card.svg' alt='' /> */}

                                </div>
                            )}
                        </div>
                    </>
                )}
            </Link>
        </>
    )
}

export default TwoCard